import { init as swipers } from "./swiper.js";
import { scrollContent, initScrollBackgroundTransition } from "./gsap.js";
import { lenis } from "./lenis.js";
import { fnc_fav_init } from "../../extend/favoritos/assets/js/this.js";

// Custom modules
import { SortingByClass } from "./modules/sorting.js";
import { initVideoPlayHandler } from "./modules/video-handler.js";
import { initMenuToggle } from "./modules/modal-toggle.js";
import { searchModel } from "./modules/search-model.js";
import { ambientModel } from "./modules/ambient-model.js";
import { productModel } from "./modules/product-model.js";
import { openModelOnCollection } from "./modules/open-modal-on-load.js";
import { downloadOnClick, initDownloadModal } from "./modules/download.js";
import loginTabsAndAjax from './modules/login.js';
import { init as filters } from "./modules/filter.js";
import { initResizeWatcher } from "./modules/resize";
import { initCardStackAnimationIndividual } from "./modules/stackcard.js";
import { createFadeInFromTopAnimation } from "./modules/cardanimation.js";
import { mapinit as map } from "./modules/map.js";
import { initSinglePieceSlider } from './modules/pieceslider.js';
import { init as backButton } from "./back-button.js";

const init = async () => {
    swipers();
    SortingByClass();
    map();
    initCardStackAnimationIndividual();
    scrollContent();
    initVideoPlayHandler();
    initScrollBackgroundTransition();
    initMenuToggle();
    searchModel();
    ambientModel();
    productModel();
    createFadeInFromTopAnimation();
    initResizeWatcher();    
    openModelOnCollection();
    fnc_fav_init();
    filters();
    loginTabsAndAjax();
    footertext();
    initDownloadPdfButton();
    initDownloadModal();
    playFirstVideoMuted(); 
    initSinglePieceSlider();    
    lenis.start();
    backButton();
};

export { init, downloadOnClick };


function footertext() {
    const sliders = document.querySelectorAll('.fade-text-slider');
    if (!sliders.length) return;
    
    sliders.forEach(slider => {
        const slides = slider.querySelectorAll('.fade-slide');
        if (slides.length < 2) return; // No need to slide if only one text

        let currentIndex = 0;
        const delay = 3000; // time each text is visible

        setInterval(() => {
            slides[currentIndex].classList.remove('active');
            currentIndex = (currentIndex + 1) % slides.length;
            slides[currentIndex].classList.add('active');
        }, delay);
    });
}

function playFirstVideoMuted() {
  const videos = document.querySelectorAll('video');
  if (videos.length > 0) {
    videos.forEach(video => {
      // Find the closest container to check visibility
      const container = video.closest('.video-container') || video.parentElement;
      const isVisible = getComputedStyle(container).display !== 'none' && getComputedStyle(video).display !== 'none';

      // Ensure attributes for mobile autoplay are present
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.muted = true;
      video.playsInline = true;

      // Only play if it's meant to autoplay AND it's visible (to avoid playing both desktop and mobile videos)
      if (isVisible && (video.hasAttribute('autoplay') || video.classList.contains('autoplay'))) {
        // Use a small timeout to ensure the browser is ready for playback after transition
        setTimeout(() => {
          // Double check if it's already playing
          if (video.paused) {
            video.play().catch(err => {
              console.warn('Autoplay failed for video:', video, err);
              
              // Fallback: try playing on first user interaction
              const playOnInteraction = () => {
                if (video.paused) {
                   video.play();
                }
                document.removeEventListener('click', playOnInteraction);
                document.removeEventListener('touchstart', playOnInteraction);
              };
              document.addEventListener('click', playOnInteraction, { once: true });
              document.addEventListener('touchstart', playOnInteraction, { once: true });
            });
          }
        }, 200); // Increased delay slightly
      }
    });
  }
}


function initDownloadPdfButton() {
  const pdfButtons = document.querySelectorAll('.js-download-pdf');
  if (!pdfButtons.length) return;

  pdfButtons.forEach(btn => {
    btn.addEventListener('click', e => {
      //e.preventDefault();

      // Prevent multiple clicks
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');

      const originalText = btn.textContent;
      const preparingText = btn.getAttribute('data-preparing-text') || 'Preparing your PDF...';
      btn.textContent = preparingText;

      // Trigger PDF creation
      setTimeout(() => {
        //window.location.href = btn.href;
        btn.textContent = originalText;
        btn.classList.remove('is-loading');
      }, 2800);
    });
  });
}